import { Pipe, PipeTransform } from '@angular/core';
import { Distributor } from '@wsphere/distributors/domain';

@Pipe({
  name: 'selectedFirst',
  standalone: false,
})
export class SelectedFirstPipe implements PipeTransform {
  /** Moves the selected distributors to the front, keeping each group in its original name order. */
  transform(
    distributors: Distributor.PartialModel[] | null,
    selected: Distributor.PartialModel[] | null
  ): Distributor.PartialModel[] {
    if (!distributors?.length) return distributors ?? [];
    if (!selected?.length) return distributors;

    const selectedIds = new Set(selected.map(distributor => distributor.id));
    const rank = (distributor: Distributor.PartialModel) => (selectedIds.has(distributor.id) ? 0 : 1);

    return [...distributors].sort((a, b) => rank(a) - rank(b));
  }
}
